import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Text,
} from "recharts";
import "../StackedBarChart/StackedBarChart.css";

const data = [
  { name: "Mon", volume: 1200, orders: 800, profit: 600, loss: 300 },
  { name: "Tue", volume: 1500, orders: 900, profit: 700, loss: 200 },
  { name: "Wed", volume: 1800, orders: 1100, profit: 900, loss: 400 },
  { name: "Thu", volume: 1700, orders: 1000, profit: 800, loss: 300 },
  { name: "Fri", volume: 2000, orders: 1200, profit: 1000, loss: 500 },
  { name: "Sat", volume: 1600, orders: 950, profit: 750, loss: 350 },
  { name: "Sun", volume: 1400, orders: 850, profit: 650, loss: 300 },
];

const CustomBarWithRadius = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 10; // Rounded corner radius
  return (
    <path
      d={`M${x},${y + radius} 
         a${radius},${radius} 0 0,1 ${radius},-${radius} 
         h${width - radius * 2} 
         a${radius},${radius} 0 0,1 ${radius},${radius} 
         v${height - radius} 
         h-${width} 
         Z`}
      fill={fill}
    />
  );
};

const StackedBarChart = () => {
  return (
    <>
      <section className="section">
        <div className="full-stacked-container">
          <div className="full-stacked-header">
            <h1>
              Weekly Performance Overview: Trading Volume, Orders, Profit, and
              Loss Trends
            </h1>
          </div>

          <div className="full-stacked-parent">
            <div className="full-stacked-chart-container">
              <ResponsiveContainer height={400}>
                <ComposedChart
                  data={data}
                  margin={{ top: 10, right: 10, left: 10, bottom: 30 }} // Add margins here
                >
                  <CartesianGrid
                    stroke="#d6d6d6"
                    strokeDasharray="0 0"
                    horizontal={true}
                    vertical={false}
                  />
                  <XAxis
                    dataKey="name"
                    label={{
                      value: "Days of the Week",
                      position: "insideLeft", // Corrected position
                      offset: 0, // Adjust for spacing
                      style: { fontSize: "16px" }, // Updated font size
                      dy: 30,
                    }}
                    tick={{ fontSize: "16px", fill: "#999" }} // Updated tick font size
                  />
                  <YAxis
                    label={{
                      value: "Count (Units)",
                      angle: -90,
                      position: "insideBottom",
                      offset: 40, // Simulates left margin
                      style: { fontSize: "16px" }, // Updated font size
                      dx: -25,
                    }}
                    tick={{ fontSize: "16px", fill: "#999" }} // Updated tick font size
                  />
                  <Tooltip
                    labelStyle={{
                      fontWeight: "bold",
                      fontSize: "16px", // Updated label font size
                      color: "#000",
                    }}
                    itemStyle={{
                      color: "#999",
                      fontSize: "16px", // Updated item font size
                    }}
                    wrapperStyle={{
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  />
                  <Bar
                    dataKey="volume"
                    stackId="a"
                    fill="#8197f8"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                  />
                  <Bar
                    dataKey="orders"
                    stackId="a"
                    fill="#a5bcfc"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                  />
                  <Bar
                    dataKey="profit"
                    stackId="a"
                    fill="#c7d7fe"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                  />
                  <Bar
                    dataKey="loss"
                    stackId="a"
                    fill="#dcdcdc"
                    barSize={window.innerWidth < 600 ? 25 : 45}
                    shape={<CustomBarWithRadius />}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
            <div className="full-stacked-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                  <td>Legend</td>
                  <td>Name</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#8197f8" }}
                      ></i>
                    </td>
                    <td>Volume</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#a5bcfc" }}
                      ></i>
                    </td>
                    <td>Orders</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#c7d7fe" }}
                      ></i>
                    </td>
                    <td>Profit</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        className="fa-solid fa-circle"
                        style={{ color: "#dcdcdc" }}
                      ></i>
                    </td>
                    <td>Loss</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StackedBarChart;
